export default __webpack_public_path__ + "static/media/Vendors.f36010ce.svg";